import {
	SYMBOL_GROUPS_FETCH,
	SYMBOL_GROUPS_IS_FETCHING,
	SYMBOL_GROUPS_API,
	SYMBOL_GROUP_EDIT,
	SYMBOL_GROUP_FILTER,
} from 'constants/symbolGroups'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

export const symbolGroupSave = (data) => (dispatch, state) => {
    let action;
    let url = SYMBOL_GROUPS_API
    if (data.symbolGroupId) {
        action = put;
        url = url + '/' + data.symbolGroupId
    }
    else
        action = post;
    dispatch(symbolGroupsIsFetching(true))
    return action(url, data)
        .then((e) => {
            return e;
        })
        .catch((e) => { dispatch(symbolGroupsIsFetching(false)); throw new Error(e) })
        //.finally(e => dispatch(symbolGroupsIsFetching(false)))
}

export const symbolGroupFetch = (id) => (dispatch, state) => {
        dispatch(symbolGroupsIsFetching(true));
        return get(SYMBOL_GROUPS_API + '/' + id)
            .finally(e => dispatch(symbolGroupsIsFetching(false)))

    }

export const symbolGroupsFetch = () => (dispatch, state) => {
    dispatch(symbolGroupsIsFetching(true));
    const filter = state().symbolGroups.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(SYMBOL_GROUPS_API, {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        })
        .then((e) => {
            dispatch(symbolGroupsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
							symbolGroupFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(symbolGroupsIsFetching(false)))

}

export const symbolGroupRemove = (id) => (dispatch, state) => {
    dispatch(symbolGroupsIsFetching(true))
    return remove(SYMBOL_GROUPS_API + '/' + id)
        .finally(e => dispatch(symbolGroupsIsFetching(false)))
}

export const symbolGroupsFetched = (payload) => ({ type: SYMBOL_GROUPS_FETCH, payload: payload })
export const symbolGroupsIsFetching = (payload) => ({ type: SYMBOL_GROUPS_IS_FETCHING, payload: payload })
export const symbolGroupEdit = (id, data) => ({ type: SYMBOL_GROUP_EDIT, payload: data })
export const symbolGroupFilter = (data) => ({ type: SYMBOL_GROUP_FILTER, payload: data })


// WEBPACK FOOTER //
// ./src/actions/symbolGroups.js